import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useCanAccessGroupManagement } from '@/entities/user';
import { AppRoutes } from '@/shared/constants/app-routes.constant';

const GroupManagementElementComponent = ({ children }: PropsWithChildren) => {
	const canAccessGroupManagement = useCanAccessGroupManagement();

	if (canAccessGroupManagement) {
		return <>{children}</>;
	}

	return <Navigate to={AppRoutes.Home} />;
};

export default GroupManagementElementComponent;
